import { message } from 'doraemon';

export const MSG = {
  DEFAULT: '系统开小差了，请尝试刷新！',
  CANCEL: '如果取消，您选择的数据将会丢失',
};

/**
 * 请求错误信息统一处理
 * @param {string} message 提示消息，默认系统开小差了，请尝试刷新！
 */
export const responseErrorHandle = msg => {
  message.error(msg || MSG.DEFAULT);
};

// 区分组织单位机构code
export const TASK_SOURCE = {
  orgCode: 0,
  unitCode: 1,
};

// 发票文件上传格式
export const NOTE_ACCEPT = '.jpg,.jpeg,.png,.bmp,.pdf,.ofd';
// 合同文档文件格式
export const CONTRACT_ACCEPT = '.pdf,.doc,.docx,.zip,.rar,.7z,.wps';
// 合同附件
export const CONTRACT_ATTACHMENTS_ACCEPT =
  '.jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx,.gif,.bmp,.ppt,.pptx,.zip,.rar,.ofd,.7z,.wps,.et,.dps';
// 合同附件v2
export const CONTRACT_ATTACHMENTS_ACCEPT_V2 = '.doc,.docx,.pdf,.png,.jpg,.jpeg,.zip,.7z';
// 合同补充协议文件格式
export const CONTRACT_ATTACHMENTS_ACCEPT_V3 = '.doc,.docx,.pdf,.png,.jpg,.jpeg';
// excel-文件导入
export const EXCEL_ACCEPT = '.xls,.xlsx,.et';
// Image-内容管理
export const IMAGE_ACCEPT = '.jpg,.jpeg,.png';
// 通用文件格式
export const ACCEPT =
  '.jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx,.gif,.bmp,.ppt,.pptx,.zip,.rar,.ofd,.wps,.et,.dps';

export const OTHER_ACCEPT = '.txt,.rtf,.csv,.html,.ods';
/**
 * 文件格式展示文案
 * @param {*} specialAccept 特殊格式展示
 * @param {*} params 附件格式
 * @returns
 */
export const formatAccept = (
  specialAccept,
  { accept = ACCEPT, fileNum, maxFileSize, tipText },
  newFormat,
) => {
  let commonText = tipText || `支持格式为图片、文档、压缩包等，每个文件大小${maxFileSize}M以内。`;
  if (specialAccept) {
    commonText = `最多支持上传${fileNum}个文件，每个文件大小${maxFileSize}M内，支持格式为${accept
      ?.split(',')
      ?.map(item => item?.slice(1))
      ?.join('、')}`;
  }
  // 新文案格式
  if (newFormat) {
    commonText = `最多支持上传${fileNum}个文件，每个文件大小${maxFileSize}M内，支持上传图片、word文档、Excel表格、压缩包、pdf等文件格式`;
  }
  return commonText;
};
export const BIZ_CODE = 1199;
export const PUBLIC_BIZ_CODE = 1139; //
export const PUBLIC_PERMANENT_BIZ_CODE = 1221; // 浙里报公共不过期bizCode
/**
 * 文件大小限制
 * @param {*} fileSize 文件大小（M）
 * @returns
 */
export const formatMaxFileSize = (fileSize = 10) => {
  return fileSize * 1024 * 1024;
};

const zcyDomain = {
  'www.zlb.cai-inc.com': 'develop', // 开发
  'www.zlb-test.cai-inc.com': 'test', // 测试
  'www.zlb-staging.cai-inc.com': 'staging', // 预发
  'zlb.czt.zj.gov.cn': 'online', // 真线
  // 数鲤通改造
  'www.shulitong.com': 'online', // 数鲤通真线
};

export const environment = (() => {
  const { hostname = '' } = window.location;
  return zcyDomain[hostname];
})();

export const defaultApplyFormTypeList = [1, 2, 3, 4, 5, 6, 7, 9, 10, 11];

/**
 * 工作流-审批类型
 */
export const AUDIT_TYPE = {
  or: 0, // 或签
  and: 1, // 会签
  sequence: 2, // 依次审批
};

/**
 * 工作流-审核用户类型
 */
export const USER_RANGE_TYPE = {
  department: 0, // 按部门
  organization: 1, // 按全机构
  platform: 2, // 全平台
  post: 3, // 按岗位
  range: 5, // 按范围
};

/**
 * 工作流-事件类型
 */
export const EVENT_TYPE = {
  approval: 0, // 审批
  audit: 1, // 审核
  cashier: 2, // 出纳
};

/**
 * 默认缩略图
 */
export const fileLogoEnum = {
  jpeg: 'https://sitecdn.zcycdn.com/f2e-assets/2afe6d90-19d6-4632-9e9d-a56f90c4eb1b.svg',
  jpg: 'https://sitecdn.zcycdn.com/f2e-assets/d56bbb64-2cb4-4aa0-9ad8-eaad1ba78aed.svg',
  png: 'https://sitecdn.zcycdn.com/f2e-assets/96fbb7be-9450-4f53-a36b-40bf77b6dc74.svg',
  gif: 'https://sitecdn.zcycdn.com/f2e-assets/9b675aae-2017-40c8-9d32-73c5e94f5419.svg',
  pdf: 'https://sitecdn.zcycdn.com/f2e-assets/96852ea2-7f0b-4fff-872a-972196f88ace.svg',
  docx: 'https://sitecdn.zcycdn.com/f2e-assets/05ab62ae-b681-4436-a726-78082420e74d.svg',
  doc: 'https://sitecdn.zcycdn.com/f2e-assets/720a8853-40c6-4891-98de-024e9eacdea6.svg',
  xlsx: 'https://sitecdn.zcycdn.com/f2e-assets/14047274-42a0-4556-81ec-b17c612b6e7e.svg',
  xls: 'https://sitecdn.zcycdn.com/f2e-assets/1dbe3768-1090-48da-88fb-47595b74c8d5.svg',
  pptx: 'https://sitecdn.zcycdn.com/f2e-assets/2ca7a77c-0b2e-4c3c-b708-4c8803daff84.svg',
  ppt: 'https://sitecdn.zcycdn.com/f2e-assets/91612d6f-b90d-48ea-98f2-16aff25c6a6e.svg',
  bmp: 'https://sitecdn.zcycdn.com/f2e-assets/be3c69d2-0979-48ca-ac2f-10bbcb3eee49.svg',
  zip: 'https://sitecdn.zcycdn.com/f2e-assets/15f93522-21a9-43c5-911c-945e13b19462.svg',
  rar: 'https://sitecdn.zcycdn.com/f2e-assets/08803d2a-70a3-41a9-a7f3-3014a6b76322.svg',
  ofd: 'https://sitecdn.zcycdn.com/f2e-assets/110dac86-1e98-48d8-9e72-5e1ac13934c0.svg',
  default: 'https://sitecdn.zcycdn.com/f2e-assets/930e7895-a3ae-48ea-a696-c7adb861d87b.svg',
};

/**
 * 外部跳转链接
 */
export const ZLB_INVOICE = 'https://dzpj.zjzwfw.gov.cn'; // 浙里办票

/**
 * 差旅-差旅类型下拉选项
 */
export const BUSINESS_TYPE_CODE = {
  ordinary: 1, // 普通出差
  special: 2, // 专项/会议/培训出差
  remoteAreas: 3, // 常驻地偏远地区
  expatriate: 19, // 外派（实习、挂职、借调、支援等)
  study: 36, // 进修
  other: 99, // 其他
  outing: 20, // 外出
};

/**
 * 支付配置参数
 */
export const PAY_BIZ_TYPE = {
  ORG: {
    bizType: 'org', // 业务类型
    configKey: 'configureOrgPay', // 编码
  },
  DISTRICT: {
    // 单位配置信息
    bizType: 'district',
    configKey: 'configureDistrictPay',
  },
};

/**
 * PERIOD: 上下午模式， MINUTES: 时分模式，DATE：全天模式
 */
export const PERIOD_TYPE = {
  Period: 'PERIOD',
  Range: 'MINUTES',
  FullDate: 'DATE',
};

// 上午、下午、晚上, 时间范围
export const TIME_TAG = {
  Range: 0,
  Morning: 1,
  Afternoon: 2,
  Evening: 3,
  FullDate: -1,
};

// periodType转tag
export const PERIOD_TYPE_TO_TIME_TAG = {
  [PERIOD_TYPE.Period]: 1,
  [PERIOD_TYPE.Range]: 0,
  [PERIOD_TYPE.FullDate]: -1,
};

/**
 * 根据时间tag映射文案
 */
export const PERIOD_DESC = {
  [TIME_TAG.Range]: '',
  [TIME_TAG.Morning]: '上午',
  [TIME_TAG.Afternoon]: '下午',
  [TIME_TAG.Evening]: '晚上',
  [TIME_TAG.FullDate]: '',
};

export const USER_SOURCE = {
  inner: 1,
  external: 2,
};

export const MEMBER_TAGS_ENUM = {
  1: {
    tag: '',
    renderTag: '',
    style: {},
  },
  2: {
    tag: '司机',
    renderTag: '（司机）',
    style: {
      background: '"#F4F7FF",',
      color: '"#3479FD",',
      width: '40px',
    },
  },
  3: {
    tag: '外部人员',
    renderTag: '（外部人员）',
    style: {
      background: '"#F4F7FF",',
      color: '"#3479FD",',
      width: '56px',
    },
  },
};

export const JOB_LEVEL_ENUM = {
  PROVINCIAL_AND_EQUIVALENT_LEVEL_PERSONNEL: '省级及相当职级人员',
  CHIEF_AND_DEPUTY_MINISTERS_AND_STAFF_OF_EQUIVALENT_RANK: '正副厅长及相等职级人员',
  THE_REST_OF_THE_STAFF: '其余人员',
  NO_RANK: '无职级',
};
// 工资-批量支付-银行业务类型
export const BANKING_BUSINESS_TYPE = [
  {
    label: '柜面业务',
    value: 0,
  },
  {
    label: '网银业务',
    value: 1,
  },
];

/**
 * 状态图
 * 使用场景：工作流2.0、状态流转组件
 */
export const STATUS_IMG = {
  success: 'https://sitecdn.zcycdn.com/f2e-assets/34b4ede1-ba98-4d94-b61d-60759a83d229.png',
  error: 'https://sitecdn.zcycdn.com/f2e-assets/0b5c2219-d6f5-496f-bd3b-2b9e76994348.png',
  wait: 'https://sitecdn.zcycdn.com/f2e-assets/a17f267a-8ea6-46ad-8294-337073cd018d.png',
  delete: 'https://sitecdn.zcycdn.com/f2e-assets/ac67d7a2-b9a9-416b-a808-5bd0c467c3f6.png',
};
// 工作流加签标识
export const addAuditWayImg = {
  0: 'https://sitecdn.zcycdn.com/f2e-assets/6292ac89-73de-4417-90d4-0827596a24dc.png',
  1: 'https://sitecdn.zcycdn.com/f2e-assets/66927eb2-53c1-463a-b31a-79e1f3cd9587.png',
  2: 'https://sitecdn.zcycdn.com/f2e-assets/6292ac89-73de-4417-90d4-0827596a24dc.png',
};

export const commentImg =
  'https://sitecdn.zcycdn.com/f2e-assets/6959c0be-382d-4651-8f22-ca5aac56563d.svg';
export const ECHART_COLOR = [
  '#4045F6',
  '#3479FD',
  '#2EAAEE',
  '#00BCCC',
  '#2CB360',
  '#83C911',
  '#F4BB22',
  '#F27900',
  '#F03A0D',
  '#DF1F1F',
  '#BE3CD9',
  '#8E33FF',
];

export const MEAL_TIME_LIST = [
  {
    label: '早餐',
    value: 1,
  },
  {
    label: '中餐',
    value: 2,
  },
  {
    label: '晚餐',
    value: 3,
  },
];

export const FileType = {
  0: '记账凭证',
  1: '税务发票',
  2: '财政票据',
  3: '银行回单',
  4: '车船票',
  5: '飞机行程单',
  6: '收据',
  7: '电子合同',
  8: '报销单',
  9: '申请单',
  10: '纸质合同',
  11: '申请单附件',
  12: '报销单附件',
  13: '发票版式文件',
  14: '合同附件',
  15: '记账凭证附件',
  16: '其他会计凭证数据',
  17: '财务账簿',
  18: '财务账簿附件',
  19: '财务报告',
  20: '银行回单开具凭证',
  21: '银行回单入账凭证',
  22: '税票开具凭证',
  23: '税票入账凭证',
  99: '其他',
};

export const FileTypeGroup = {
  凭证: [0, 3, 6, 15, 16, 17, 18, 19, 20, 21, 22, 23],
  报销单: [8],
  申请单: [9],
  票据: [1, 2, 4, 5, 13],
  附件: [7, 10, 11, 12, 14, 99],
};

// 资金来源名称  财政拨款对应是是国库支付，其他都是仁享支付
export const SOURCE_OF_FUNDS_LIST = [
  '温州市卫生健康委员会',
  '首都儿科研究所',
  '继续教育经费',
  '成果转化经费',
  '其他',
  '科研资金',
  '科教资金',
  // '财政拨款'
  '科研配套资金',
  '自有资金',
];
